import React, { useCallback } from 'react';
import FrameworkUtils from 'utils/framework';
import { Box, Flex } from 'components/ui';
import {
    space, fontSizes, lineHeights, colors
} from 'style/config';
import Markdown from 'components/Markdown/Markdown';
import convertMarkdownLinksToJiraFormat from 'ai/utils/convertMarkdownLinksToJiraFormat';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';
import { SIGN_IN_PATH } from 'ai/constants/superchat';

const { wrapFunctionalComponent } = FrameworkUtils;

const MESSAGE_TYPES = {
    USER_QUERY: 'sent',
    USER_QUERY_RESPONSE: 'received'
};

function Message(props) {
    const { message, onSignIn } = props;
    const type = MESSAGE_TYPES[message.message_type || message.response_type];
    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    // Intercept clicks on /signin links to open the sign-in modal instead of navigating
    const handleMessageClick = useCallback(
        event => {
            const anchor = event.target.closest('a');

            if (!anchor) {
                return;
            }

            const href = anchor.getAttribute('href');

            if (href && (href === SIGN_IN_PATH || href.includes(SIGN_IN_PATH))) {
                event.preventDefault();
                event.stopPropagation();

                if (onSignIn) {
                    onSignIn();
                }
            }
        },
        [onSignIn]
    );

    // Hide event-type messages (e.g., EVENT_USER_HAS_SIGNED_IN) from the UI
    if (message.data?.type) {
        return null;
    }

    const content = message.data?.query || message.data?.summary || message.data?.content || message.content;

    if (!type || !content) {
        return null;
    }

    const cleanContent = convertMarkdownLinksToJiraFormat(content); // Converts [text](url) → [text|url]

    return (
        <Flex css={styles.messageContainer(type)}>
            <Box
                css={[styles.message, styles[type](isGenAINewUIEnabled)]}
                onClick={handleMessageClick}
            >
                <Markdown
                    content={cleanContent}
                    targetWindow='new'
                />
            </Box>
        </Flex>
    );
}

const styles = {
    messageContainer: type => {
        if (type === 'sent') {
            return {
                justifyContent: 'flex-end',
                paddingLeft: '20%'
            };
        }

        return {
            paddingRight: '20%'
        };
    },
    message: {
        padding: space[3],
        borderRadius: 12,
        fontSize: fontSizes.base,
        lineHeights: lineHeights.tight,
        wordWrap: 'break-word'
    },
    sent: () => ({
        backgroundColor: colors.black,
        color: colors.white,
        borderBottomRightRadius: 0
    }),
    received: () => ({
        backgroundColor: colors.nearWhite,
        color: colors.black,
        borderBottomLeftRadius: 0
    })
};

export default wrapFunctionalComponent(Message, 'Message');
